import { useDetail, useList, usePartialUpdate } from '@inmagik/react-crud'
import { useQueryClient } from '@tanstack/react-query'
import { API_URL } from '../constants'
import { Proposta } from '../types'
import { PropostaClienteType } from '../typesCliente'
import { useAction } from './useData'

export function useProposteList(params: Record<string, string> = {}) {
  return useList<Proposta>(`${API_URL}/bilance/proposta`, params)
}

export function useProposta(id: string) {
  return useDetail<Proposta>(`${API_URL}/bilance/proposta`, id)
}

export function usePartialUpdateProposta() {
  return usePartialUpdate<Proposta>(`${API_URL}/bilance/proposta`)
}

export function usePropostaFinalizza(id: string) {
  const queryClient = useQueryClient()

  return useAction<Proposta, void>(`${API_URL}/bilance/proposta/${id}/finalizza`, {
    method: 'POST',
    reactQuery: {
      onSuccess: (data) => {
        queryClient.setQueryData([`${API_URL}/bilance/proposta`, id], data)
      },
    },
  })
}

// #region CLIENTE
export function useProposteListCliente(params: Record<string, string> = {}) {
  return useList<PropostaClienteType>(`${API_URL}/bilance/proposta`, params)
}

export function usePropostaCliente(id: string) {
  return useDetail<PropostaClienteType>(`${API_URL}/bilance/proposta`, id)
}
